<!-- バックヤード > カテゴリー編集 -->
<template>
  <div>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <category-form />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import CategoryForm from './_Form'

export default {
  name: 'CategoriesEdit',
  components: {
    CategoryForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: 'カテゴリー一覧', disabled: false, to: '/backyard/categories', exact: true },
        { text: 'カテゴリー編集', disabled: true, to: '' },
      ],
    }
  },
  created() {},
  methods: {},
}
</script>

<style lang="scss">

</style>
